import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

import { getRootURL } from '../../../lib';
import { Word } from '../../../containers';
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { useState } from 'react'
import { Auth0Context } from '../../../Parts/Auth0'
import { useEffect } from 'react'
import { useReducer } from 'react'
import { signUp as signUpLimit } from '../../../constants/Limit'
import { accountSettings as accountSettingsLimit } from '../../../constants/Limit'
import { useHistory } from 'react-router-dom'


const styles = theme => ({
  card: {
    maxWidth: 400,
    height: 400,
  },
  cardHeader: {
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: 0,
  },
  cardContent: {
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',  
    position: 'absolute',
    bottom: 0,
  },
  userName: {
    align: 'center',
    width: '100%',
    maxWidth: 300,
  },
  displayName: {
    width: '100%',
    maxWidth: 300,
  },
  registerButton: {
    margin: theme.spacing.unit,
  }
})

const ACTION_TYPE = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  CHANGED_TEXT: 'CHANGED_TEXT',
}

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.ENABLED:
      return { ...state, disabled: false }
    case ACTION_TYPE.DISABLED:
      return { ...state, disabled: true }
    case ACTION_TYPE.CHANGED_TEXT:
      if (action.name === 'userName') {
        if (action.text.length > signUpLimit.stringLength.userName) {
          return state
        }
        if (Boolean(action.text.match(signUpLimit.format.userName))) {
          return state
        }
      }
      else if (action.name === 'displayName') {
        if (action.text.length > accountSettingsLimit.stringLength.displayName) {
          return state
        }
      }
      return { ...state, [action.name]: action.text }
    default:
      return state
  }
}

function SignUpCard(props) {
  const { init, user, classes, handleRegister, language } = props
  const auth0Context = useContext(Auth0Context)
  const [listenerID, setListenerID] = useState()
  const [isInitialized, setIsInitialized] = useState(false)

  const [{ userName, displayName, disabled }, dispatch] = useReducer(reducer, {
    userName: '',
    displayName: '',
    disabled: false,
  })

  const history = useHistory()

  useEffect(() => {
    if (user) {
      init(user, history)
      setIsInitialized(true)
      dispatch({
        type: ACTION_TYPE.CHANGED_TEXT,
        name: 'displayName',
        text: user.nickname
      })
    }
    setListenerID(auth0Context.onAuthStateChanged(changedUser => {
      if (changedUser && !isInitialized) {
        init(changedUser, history)
        setIsInitialized(true)
        dispatch({
          type: ACTION_TYPE.CHANGED_TEXT,
          name: 'displayName',
          text: changedUser.nickname
        })
      }
    }))
    return () => {
      if (listenerID) {
        auth0Context.unregisterAuthStateChanged(listenerID)
      }
    }
  }, [])

  return (
    <Card className={classes.card}>
      <CardHeader title={<Word wid={WID.SIGN_UP_CARD.CARD_TITLE}/>} className={classes.cardHeader}/>
      <CardContent className={classes.cardContent}>
        <Typography></Typography>
        <TextField
          label={<Word wid={WID.SIGN_UP_CARD.USER_NAME_LABEL}/>}
          helperText={`${getRootURL()}/user/${userName}`}
          className={classes.userName}
          onChange={event => dispatch({
            type: ACTION_TYPE.CHANGED_TEXT,
            name: 'userName',
            text: event.target.value,
          })}
          margin='normal'
          value={userName}
          disabled={disabled}
        />
        <TextField
          label={<Word wid={WID.SIGN_UP_CARD.DISPLAY_NAME_LABEL}/>}
          helperText={''}
          className={classes.displayName}
          onChange={event => dispatch({
            type: ACTION_TYPE.CHANGED_TEXT,
            name: 'displayName',
            text: event.target.value
          })}
          margin='normal'
          value={displayName}
          disabled={disabled || !Boolean(user)}
        />
      </CardContent>
      <CardActions className={classes.cardActions}>
        <Button
          variant='contained'
          color='primary'
          disabled={disabled || (userName.length === 0 || displayName.length === 0)}
          onClick={handleRegister(userName, displayName, history, language)}
          className={classes.registerButton}
        >
          <Word wid={WID.SIGN_UP_CARD.REGISTER_BUTTON}/>
        </Button>
      </CardActions>
    </Card>
  )
}

export default withStyles(styles)(SignUpCard)


// WEBPACK FOOTER //
// ./src/Pages/SignUp/components/SignUpCard.js